import * as React from "react";
import i18n from "../../../../../i18n/i18n";
import {Chip} from "@mui/material";
import Row from "../../../../../common/components/shared/row/row";
import SimpleInfoElement from "../../../../../common/components/shared/simpleInfoElement/simpleInfoElement";
import {Utils} from "../../../../../helpers/utils";
import Checkbox from "../../../../../common/components/shared/checkbox/checkbox";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {useContext} from "react";
import {storesContext} from "../../../../../common/stores/stores";
import {observer} from "mobx-react";


interface AdditionalEquipmentProps {
    type: "entry" | "exit"
    icon: JSX.Element;
    isUpdate: boolean;
}

function AdditionalEquipment(props: AdditionalEquipmentProps): React.ReactElement {
    const isEntry = props.type === "entry";
    const isEntryOrExitTestId = props.type;
    const tcrStore = useContext(storesContext).tcrStore;

    const entryWinch = tcrStore.entryWinch;
    const exitWinch = tcrStore.exitWinch;
    const entryPlumb = tcrStore.entryPlumb;
    const exitPlumb = tcrStore.exitPlumb;
    const entrySpareWheelsNo = tcrStore.entrySpareWheelsNo;
    const exitSpareWheelsNo = tcrStore.exitSpareWheelsNo;
    const entryWedgesNo = tcrStore.entryWedgesNo;
    const exitWedgesNo = tcrStore.exitWedgesNo;

    return (
        <div className="section two-sections">
            <div className="section-header">
                {i18n.t("transportation.order.tcr.sections.additionalEquipment.header")}
                <Chip
                    className={`tcr-chip ${isEntry ? "tcr-chip-entry" : "tcr-chip-exit"}`}
                    label={isEntry ? i18n.t("orderStatus.DEPO_ENTERED") : i18n.t("orderStatus.DEPO_EXITED")}
                    icon={props.icon}
                    data-testid="additional-equipment-section-chip"
                />
            </div>

            {props.isUpdate ? renderContentModification() : renderContentView()}
        </div>
    );

    function renderContentView() {
        return (
            <div className="section-content">
                <Row class="flex-type gap-20 nowrap">
                    {renderWinchAndPlumbView()}
                </Row>
                {renderSpareWheelAndWedgeView()}
            </div>
        );
    }

    function renderWinchAndPlumbView() {
        return (
            <>
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.equipmentType.WINCH")}
                    value={Utils.renderBooleanYesNoValue(isEntry ? entryWinch.value : exitWinch.value, true)}
                    testId={`${isEntryOrExitTestId}-winch`}
                />
                <SimpleInfoElement
                    label={i18n.t("transportation.order.tcr.equipmentType.PLUMB")}
                    value={Utils.renderBooleanYesNoValue(isEntry ? entryPlumb.value : exitPlumb.value, true)}
                    testId={`${isEntryOrExitTestId}-plumb`}
                />
            </>
        );
    }

    function renderSpareWheelAndWedgeView() {
        return (
            <>
                <Row class="flex-type">
                    <SimpleInfoElement
                        label={`${i18n.t("transportation.order.tcr.equipmentType.SPARE_WHEEL")} (${i18n.t("transportation.order.tcr.sections.additionalEquipment.quantity")})`}
                        value={isEntry ? entrySpareWheelsNo.value : exitSpareWheelsNo.value}
                        testId={`${isEntryOrExitTestId}-spare-wheel`}
                    />
                </Row>
                <Row class="flex-type">
                    <SimpleInfoElement
                        label={`${i18n.t("transportation.order.tcr.equipmentType.WEDGE")} (${i18n.t("transportation.order.tcr.sections.additionalEquipment.quantity")})`}
                        value={isEntry ? entryWedgesNo.value : exitWedgesNo.value}
                        testId={`${isEntryOrExitTestId}-wedge`}
                    />
                </Row>
            </>
        );
    }

    function renderContentModification() {
        return (
            <div className="section-content">
                <Row class="flex-type gap-20 nowrap">
                    {renderWinchAndPlumbModification()}
                </Row>
                {renderSpareWheelAndWedgeModification()}
            </div>
        );
    }

    function renderWinchAndPlumbModification() {
        return (
            <>
                <Checkbox
                    validatedValue={isEntry ? entryWinch : exitWinch}
                    label={i18n.t("transportation.order.tcr.equipmentType.WINCH")}
                    testId={`${isEntryOrExitTestId}-winch-input`}
                    onChange={() => {
                        tcrStore.setIsEdit(true);
                    }}
                />
                <Checkbox
                    validatedValue={isEntry ? entryPlumb : exitPlumb}
                    label={i18n.t("transportation.order.tcr.equipmentType.PLUMB")}
                    testId={`${isEntryOrExitTestId}-plumb-input`}
                    onChange={() => {
                        tcrStore.setIsEdit(true);
                    }}
                />
            </>
        );
    }

    function renderSpareWheelAndWedgeModification() {
        return (
            <>
                <Row class="flex-type">
                    <TextInput
                        validatedValue={isEntry ? entrySpareWheelsNo : exitSpareWheelsNo}
                        label={`${i18n.t("transportation.order.tcr.equipmentType.SPARE_WHEEL")} (${i18n.t("transportation.order.tcr.sections.additionalEquipment.quantity")})`}
                        testId={`${isEntryOrExitTestId}-spare-wheel-input`}
                        onChange={() => {
                            tcrStore.setIsEdit(true);
                        }}
                    />
                </Row>
                <Row class="flex-type">
                    <TextInput
                        validatedValue={isEntry ? entryWedgesNo : exitWedgesNo}
                        label={`${i18n.t("transportation.order.tcr.equipmentType.WEDGE")} (${i18n.t("transportation.order.tcr.sections.additionalEquipment.quantity")})`}
                        testId={`${isEntryOrExitTestId}-wedge-input`}
                        onChange={() => {
                            tcrStore.setIsEdit(true);
                        }}
                    />
                </Row>
            </>
        );
    }
}

export default observer(AdditionalEquipment);